import ComponentBase from 'components/_base/ComponentBase';

const HotelPricesButtons = ComponentBase.extend({
	template: require('./hotelPricesButtons.hbs'),
	componentClass: 'mainBox-hotel-detail-panel-prices',

	events: {
		'click .lowest-price': 'onClickInLowestPrice',
		'click .regular-price': 'onClickInRegularPrice'
	},
	initialize(options) {
        this.widget = options.widget;
        this.renderData(options.properties.hotelData);
    },
    updateContent(hotelData) {
        return this.renderData(hotelData);
    },
    renderData(hotelData) {
        const { currencySign } = this.widget.config;
		const lowestPrice = Math.trunc(hotelData.lowestPrice);
        const regularPrice = Math.trunc(hotelData.regularPrice);
        this.hotelData = hotelData;
		this.templateConfig = {
            lowestPrice: lowestPrice,
            regularPrice: regularPrice,
            currencySign: currencySign,
            currencyPrefix: this.widget.config.currencyPrefix,
            currencyPostfix: !this.widget.config.currencyPrefix
        };
        this.$el.replaceWith(this.render().$el);
        return this.el;
    },
	onClickInLowestPrice(event) {
		this.widget.api.onClickInLowestPrice(event, this.hotelData.hotelCode);
	},
	onClickInRegularPrice(event) {
		this.widget.api.onClickInRegularPrice(event, this.hotelData.hotelCode);
	}
});
export default HotelPricesButtons;



// WEBPACK FOOTER //
// ./src/components/hotelDetailPanel/hotelPricesButtons/HotelPricesButtons.js